// React
import React from "react";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import AgencyReportsOptions from "common/ui/components/nav/AgencyReportsOptions";
const AgencyReportsView = (props) => {
    return (React.createElement(Page, null,
        React.createElement(PageHeading, { reportName: "Agency" }),
        React.createElement(PageContainer, null,
            React.createElement(AgencyReportsOptions, { agencyId: props.params.agencyId }))));
};
export default AgencyReportsView;
